module.exports = __webpack_public_path__ + "static/media/globas.b5613837.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/globas.svg
// module id = 114
// module chunks = 0